import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Sparkles, ShieldCheck, Zap, CreditCard } from 'lucide-react';
import { trackInitiateCheckout } from '../utils/metaPixel';
const basicFeatures = ['6 Tomos completos de PNL aplicada', '6 Bonos incluidos', 'Acceso inmediato en PDF', 'Garantía de 7 días'];
const premiumBonuses = ['PNL en 24 Hs', 'Manual Maestro de Comunicación e Influencia', 'Kit Profesional de Protocolos PNL', 'Cuaderno de Reprogramación Mental'];
export function PricingCards() {
  return <section id="pricing" className="py-20 px-4 scroll-mt-28 relative overflow-hidden" data-id="element-217">
      {/* Ambient glow */}
      <div className="absolute top-1/3 right-0 w-[400px] h-[400px] bg-gold/10 rounded-full blur-[130px] pointer-events-none" data-id="element-218" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-219">
        <div className="text-center mb-4" data-id="element-220">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-gold/10 border border-gold/30 text-gold-light text-xs font-semibold tracking-widest uppercase" data-id="element-221">
            <Sparkles className="w-3.5 h-3.5" data-id="element-222" /> Oferta por tiempo limitado
          </span>
        </div>
        <div className="text-center mb-12" data-id="element-223">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-3" data-id="element-224">
            ELEGÍ TU MEGAPACK
          </h2>
          <p className="text-gray-400 max-w-lg mx-auto" data-id="element-225">
            Dos formas de empezar tu transformación. Elegí la que más te
            potencia.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch max-w-3xl mx-auto" data-id="element-226">
          {/* Basic: MEGAPACK PNL */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} whileHover={{
          y: -4
        }} className="bg-dark-lighter border border-dark-border rounded-2xl p-6 flex flex-col hover:border-gold/40 transition-colors" data-id="element-227">
            <div className="mb-5" data-id="element-228">
              <div className="flex items-center gap-2 mb-1" data-id="element-229">
                <span className="text-xl" data-id="element-230">📘</span>
                <h3 className="text-lg font-heading font-bold text-white" data-id="element-231">
                  MEGAPACK PNL
                </h3>
              </div>
              <p className="text-gray-400 text-sm" data-id="element-232">
                El sistema esencial · 6 Tomos + 6 Bonos
              </p>
            </div>

            <div className="mb-5 pb-5 border-b border-dark-border/60" data-id="element-233">
              <div className="flex items-center gap-2 mb-1" data-id="element-234">
                <span className="text-gray-500 line-through text-sm" data-id="element-235">
                  $69.000
                </span>
                <span className="text-[10px] font-bold text-green-400 bg-green-500/10 px-2 py-0.5 rounded-full" data-id="element-236">
                  -71%
                </span>
              </div>
              <div className="flex items-baseline gap-1.5" data-id="element-237">
                <span className="text-4xl font-heading font-bold text-white" data-id="element-238">
                  $19.990
                </span>
                <span className="text-sm text-gray-400" data-id="element-239">ARS</span>
              </div>
              <p className="text-xs text-gray-500 mt-1" data-id="element-240">
                o en cuotas con Mercado Pago
              </p>
            </div>

            <ul className="space-y-2.5 mb-6 text-sm text-gray-300 flex-grow" data-id="element-241">
              {basicFeatures.map(f => <li key={f} className="flex items-start gap-2.5" data-id="element-242">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-243" />
                  <span data-id="element-244">{f}</span>
                </li>)}
            </ul>

            <div className="mt-auto" data-id="element-245">
              <motion.a href="https://academiaholisticaargentina.com/cart/48928799129850:1" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('MegaPack PNL', 19990)} whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="block w-full py-3.5 text-center bg-dark-card border border-gold/50 text-gold-light hover:bg-gold/10 font-bold rounded-xl transition-all" data-id="element-246">
                → QUIERO EL MEGAPACK
              </motion.a>
              <p className="text-center text-[11px] text-gray-500 mt-3 flex items-center justify-center gap-1.5" data-id="element-247">
                <ShieldCheck className="w-3.5 h-3.5" data-id="element-248" /> Compra protegida ·
                Garantía 7 días
              </p>
            </div>
          </motion.div>

          {/* Premium: MEGAPACK PNL PREMIUM */}
          <motion.div id="oferta-premium" initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.15
        }} whileHover={{
          y: -6
        }} className="relative bg-dark-card rounded-2xl p-6 flex flex-col shadow-[0_0_50px_rgba(212,168,67,0.2)] md:-mt-3 md:mb-3 scroll-mt-32" data-id="element-249">
            {/* Animated gold border */}
            <div className="absolute inset-0 rounded-2xl border-2 border-gold pointer-events-none" data-id="element-250" />
            <div className="absolute inset-0 rounded-2xl bg-gradient-to-b from-gold/[0.06] to-transparent pointer-events-none" data-id="element-251" />

            {/* Ribbon badge */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-gold to-gold-light text-dark font-bold px-5 py-1.5 rounded-full text-xs tracking-widest flex items-center gap-1.5 shadow-[0_4px_20px_rgba(212,168,67,0.4)] whitespace-nowrap z-10" data-id="element-252">
              <Sparkles className="w-3.5 h-3.5" data-id="element-253" /> EL MÁS ELEGIDO
            </div>

            <div className="relative z-10 flex flex-col h-full" data-id="element-254">
              <div className="mb-5 mt-2" data-id="element-255">
                <div className="flex items-center gap-2 mb-1" data-id="element-256">
                  <span className="text-xl" data-id="element-257">🏆</span>
                  <h3 className="text-lg font-heading font-bold text-white" data-id="element-258">
                    MEGAPACK PNL PREMIUM
                  </h3>
                </div>
                <p className="text-gold-light text-sm font-medium" data-id="element-259">
                  Todo el básico + 4 Bonos Premium exclusivos
                </p>
              </div>

              <div className="mb-5 pb-5 border-b border-gold/20" data-id="element-260">
                <div className="flex items-center gap-2 mb-1" data-id="element-261">
                  <span className="text-gray-500 line-through text-sm" data-id="element-262">
                    $99.000
                  </span>
                  <span className="text-[10px] font-bold text-gold bg-gold/15 px-2 py-0.5 rounded-full" data-id="element-263">
                    AHORRÁS $69.010
                  </span>
                </div>
                <div className="flex items-baseline gap-1.5" data-id="element-264">
                  <span className="text-4xl font-heading font-bold text-white" data-id="element-265">
                    $29.990
                  </span>
                  <span className="text-sm text-gray-400" data-id="element-266">ARS</span>
                </div>
                <p className="text-xs text-gray-400 mt-1 flex items-center gap-1.5" data-id="element-267">
                  <CreditCard className="w-3.5 h-3.5 text-gold" data-id="element-268" /> o en cuotas
                  con Mercado Pago
                </p>
              </div>

              <ul className="space-y-2.5 mb-4 text-sm flex-grow" data-id="element-269">
                <li className="flex items-start gap-2.5 text-white font-medium" data-id="element-270">
                  <Check className="w-4 h-4 text-green-500 shrink-0 mt-0.5" data-id="element-271" />
                  <span data-id="element-272">Todo lo del MegaPack PNL</span>
                </li>
                <li className="pt-1" data-id="element-273">
                  <span className="text-[11px] uppercase tracking-widest text-gold-light font-bold flex items-center gap-1.5" data-id="element-274">
                    <Gift className="w-3.5 h-3.5" data-id="element-275" /> Bonos Premium
                  </span>
                </li>
                {premiumBonuses.map(bonus => <li key={bonus} className="flex items-start gap-2.5 text-gray-200" data-id="element-276">
                    <Sparkles className="w-4 h-4 text-gold shrink-0 mt-0.5" data-id="element-277" />
                    <span data-id="element-278">{bonus}</span>
                  </li>)}
              </ul>

              <div className="mt-auto" data-id="element-279">
                <motion.a href="https://academiaholisticaargentina.com/cart/49530754236666:1" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout('MegaPack PNL Premium', 29990)} whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="block w-full py-4 text-center bg-gradient-to-r from-gold to-gold-light text-dark font-bold rounded-xl shadow-[0_0_25px_rgba(212,168,67,0.35)] hover:shadow-[0_0_40px_rgba(212,168,67,0.55)] transition-all animate-pulse-slow" data-id="element-280">
                  → QUIERO EL PREMIUM
                </motion.a>
                <p className="text-center text-[11px] text-gray-400 mt-3 flex items-center justify-center gap-1.5" data-id="element-281">
                  <Zap className="w-3.5 h-3.5 text-gold" data-id="element-282" /> Acceso inmediato ·
                  Garantía 7 días
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        <p className="text-center text-xs text-gray-500 mt-8 flex items-center justify-center gap-2 flex-wrap" data-id="element-283">
          <ShieldCheck className="w-4 h-4 text-gold" data-id="element-284" />
          Pago 100% seguro · Mercado Pago, Tarjeta o Transferencia · Acceso en 5
          minutos
        </p>
      </div>
    </section>;
}